export default "__VITE_ASSET__ztHJzwD2__"